export default "__VITE_ASSET__BqRsTgbT__"